// extracted by mini-css-extract-plugin
export default {"shell":"App_shell__1LQeX","navbar":"App_navbar__e5gV3","navbar2":"App_navbar2__N7uvc","icon":"App_icon__56Luw"};